import React from "react";
import { Helmet } from "react-helmet";

function Error() {
  return (
    <div>
      <Helmet>
        <title>Page not found.</title>
      </Helmet>
      <h2>404 </h2>
      <p>Page not found.</p>
    </div>
  );
}

export default Error;
